import type { Locale } from '../locale';
import { legalEn } from './en';
import { legalZhTW } from './zh-TW';
import { legalJa } from './ja';
import { legalKo } from './ko';
import { legalTh } from './th';
import type { LegalCopy } from './types';

/** Every locale's privacy policy and terms. Imported lazily on the client (see ./index.ts). */
export const LEGAL_TEXTS: Record<Locale, LegalCopy> = { en: legalEn, 'zh-TW': legalZhTW, ja: legalJa, ko: legalKo, th: legalTh };
